import { Skeleton } from '../ui/skeleton';

const LevelBreakdownSkeleton = () => {
    return (
        <div className="border border-neutral-300 rounded-xl p-6">
            <Skeleton className="h-6 w-1/3 mb-4" />
            <div className="flex flex-col gap-3">
                <div className="flex justify-between">
                    <Skeleton className="h-4 w-1/4" />
                    <Skeleton className="h-4 w-1/4" />
                </div>
                <Skeleton className="h-2 w-full" />
                <Skeleton className="h-4 w-1/3" />
            </div>
        </div>
    );
};

export default LevelBreakdownSkeleton;
